import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMagnify = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.16667 3.75C6.17512 3.75 3.75 6.17512 3.75 9.16667C3.75 12.1582 6.17512 14.5833 9.16667 14.5833C10.6626 14.5833 12.0159 13.9777 12.9968 12.9968C13.9777 12.0159 14.5833 10.6626 14.5833 9.16667C14.5833 6.17512 12.1582 3.75 9.16667 3.75ZM2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667C15.8333 10.7823 15.258 12.2645 14.302 13.4181L17.5505 16.6667L16.6667 17.5505L13.4181 14.302C12.2645 15.258 10.7823 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667Z",
		fill: "currentColor"
	})]
});
export default SvgMagnify;
